/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientDiagnosisApi } from '../api/patientdiagnosis.api';
import { switchMap, map } from 'rxjs/operators';
import { PatientMensturalData, PatientMenstural } from '../../../interfaces/masters/patientMenstural';
import { PatientMensturalApi } from '../api/patientMenstural.api';

@Injectable()
export class PatientMensturalService extends PatientMensturalData {

  constructor(private api: PatientMensturalApi) {
    super();
  }


  list(url: string): Observable<PatientMenstural[]> {
    return this.api.list(url);
  }


  create(url: string, data: PatientMenstural): Observable<PatientMenstural> {
    return this.api.add(url,data);
  }

  update(url: string, data: PatientMenstural): Observable<PatientMenstural> {
    return this.api.update(url,data);
  }



  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
